import { retornaLabelDoValorParentesco, validatorEstrtutura1, validatorMaiorIgual65Anos, validatorParentescoEmDuplicidade, validatorPossui9Dependentes } from './funcoesAuxiliaresZCC';

export class CorrenteEdicaoZCC {
    constructor(
        dependentes,
        parentesco,
        categorias,
        valoresForm,
        valoresAnterioresForm
    ) {
        this.dependentes = dependentes;
        this.parentesco = parentesco;
        this.categorias = categorias;
        this.arrayMsgsErro = [];
        this.valoresForm = valoresForm;
        this.valoresAnterioresForm = valoresAnterioresForm;
    }

    possui2DependentesMaiorIgual65Anos() {
        if (validatorMaiorIgual65Anos(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro.push('O plano ZELO CONFORTO NORDESTE permite apenas 2 dependentes com idade maior ou igual a 65 anos.');
        }

        return this;
    }

    dependentesDentroDaEstrutura1() {
        if (validatorEstrtutura1(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro.push('O plano ZELO CONFORTO NORDESTE permite somente dependentes do tipo cônjuge, pai, mãe, sogro, sogra, filhos de até 30 anos');
        }

        return this;
    }

    possui9Dependentes() {
        if (validatorPossui9Dependentes(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro.push('O plano ZELO CONFORTO NORDESTE permite apenas 9 dependentes');
        }

        return this;
    }

    parentescoEmDuplicidade() {
        if (validatorParentescoEmDuplicidade(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro.push(`${retornaLabelDoValorParentesco(this.parentesco)}`);
        }

        return this;
    }
}
